import React from "react"
import {Switch, Route, Redirect} from "react-router-dom";

import Containers from "../../Containers";

const Aside = () => {
	return (

			<aside className="aside">
				<Switch>
					<Route exact path="/">
						<Containers.Dashboard/>
					</Route>
					<Route exact path="/login">
						<Redirect to="/" />
					</Route>
					<Route path="/order/:id">
						<Containers.Dashboard/>
					</Route>
					<Route path="/history">
						<Containers.History/>
					</Route>
					<Route path="/point">
						<Containers.Point/>
					</Route>
					<Route path="/logout">
						<Containers.Logout/>
					</Route>
				</Switch>
			</aside>

	)
}

export default Aside
